;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.selectOption = (function () {
    const initialize = function () {
      $('.js-selectOption').on('click', function (e) {
        e.preventDefault()
        const $this = $(this)
        const content = $this.html()
        const $button = $this.closest('.button')
        const $category = $this.closest('.categorySelector')
        const val = $this.attr('data-value')

        // make it work for the front end
        if ($this.parents().is('.searchCriteria, .blogFilter')) {
          // switch content on search page
          $this.closest('.button, .categorySelector').toggleClass('is-open').find('.value').html(content)
        } else if ($this.parents().is('.spmenu-search, .neighborhood-dropdown, .location-dropdown-form')) {
          // switch content on search menu
          $this.closest('.button, .categorySelector').toggleClass('is-open').find('.parameter').html(content)
        }

        // but secretly make it work for real using hidden inputs
        $button.find('input').val(val)

        // code specific to blog selector on mobile view
        if ($category.length) {
          $this.parent().addClass('is-selected').siblings().removeClass('is-selected')
          $category.find('.open').toggle()
        }
      })

      // go ahead and click the correct items to handle any page load values that are set
      $('input[type=\'hidden\'].custom-drop', '#home-search').each(function () {
        const $this = $(this)
        const val = $this.attr('value')
        const $button = $this.parents('.button')
        const $category = $this.parents('.categorySelector')
        const $list = $button.find('.menu')
        const selector = 'a[data-value="' + val + '"]'
        const $listItem = $list.find(selector)

        if ($listItem.length) {
          $button.addClass('is-open')
          $category.addClass('is-open')
          $listItem.trigger('click')
        }
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.selectOption.initialize()
  })
}(jQuery, window))
